export default __webpack_public_path__ + "static/media/frame_vi_pc@2x.2dd8183e.png";